import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AlertComponent } from 'src/app/layout/extensions/alert/alert.component';
import { AlertControl } from 'src/app/utils/alert/alert-control';
import { ConstantAlertBtn } from 'src/app/utils/common/constant-alert-msg';
import { ConstantAlertType } from 'src/app/utils/common/constant-alert-type';
import { ResponseMsg } from 'src/app/utils/common/response-msg-aas';
import { ServiceMsg } from 'src/app/utils/common/validate-msg-aas';
import { UsbTokenConfig } from 'src/app/utils/models/aas-models/signature/list-usb-token/usb-token-config';
import { SignatureService } from 'src/app/utils/services/aas-network/signature.service';

const default_img = "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";
const base64_prefix = 'data:image/png;base64,';

@Component({
  selector: 'app-usb-token-config',
  templateUrl: './usb-token-config.component.html',
  styleUrls: ['./usb-token-config.component.scss']
})
export class UsbTokenConfigComponent implements OnInit {
  visiableType = 1;
  @Input()
  set config(value) { this._config = value; }
  get config(): UsbTokenConfig {  return this._config; }
  _config: any;
  @Input()
  set configId(value) { this._configId = value; }
  get configId() { return this._configId;}
  _configId: string = "";

  @Output("cancel") cancel: EventEmitter<any> = new EventEmitter<any>();
  @Output("save") save: EventEmitter<any> = new EventEmitter<any>();

  formConfig: FormGroup;
  isSubmit = false;
  validMsg = ServiceMsg.SIGNATURE_CONFIG;
  options = [
    { id: 0, name: this.translate.instant("ContractCensorship_ts_11") },
    { id: 1, name: this.translate.instant("ServiceContractDetail_usbtoken_signType_imageDescrip") },
    { id: 2, name: this.translate.instant("ServiceContractDetail_usbtoken_signType_onlyImage") }
  ];
  inputFileLabel = "ESign_ts_1";
  imgContent = base64_prefix + default_img;
  fileImg: File = null;
  fileType = ['image/jpeg', 'image/png', 'image/jpg'];

  constructor(
    private fb: FormBuilder,
    private signatureService: SignatureService,
    private modalService: NgbModal,
    private alert: AlertControl,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.viewDidLoad();
  }

  viewDidLoad() {
    this.makeFormConfig();
    this.setData();
  }

  makeFormConfig() {
    this.formConfig = this.fb.group({
      signerName: new FormControl('',),
      textColor: new FormControl('',),
      visibleType: new FormControl(0),
      base64Image: new FormControl(''),
      fontSize: new FormControl(8, [Validators.min(8), Validators.max(20), Validators.pattern(/^[0-9]+$/)]),
      signBy: new FormControl(false),
      signDate: new FormControl(false),
      imageFile: new FormControl(''),
    })
  }

  setData() {
    console.log(this.config);
    this.formConfig.patchValue({
      visibleType: this.config.visibleType || 0 ,
      base64Image: this.config.base64Image || default_img,
      fontSize: this.config.fontSize || 8,
      signBy: this.config.signBy,
      signDate: this.config.signDate,
      imageFile: "",
    });

    this.imgContent = this.config.base64Image ?  base64_prefix + this.config.base64Image : base64_prefix + default_img;
  }
  
  //MARK: Input file
  handleFileInput(e) {
    this.fileImg = e.target.files && e.target.files.item(0);
    if (this.fileImg && this.fileImg !== null && this.fileImg !== undefined) {
      this.inputFileLabel = this.fileImg.name;

      if (!this.fileType.includes(this.fileImg.type)) {
        this.formConfig.controls.imageFile.setErrors({ type: true });
        this.imgContent = '';
      } else if (this.fileImg.size > 2000000) {
        this.formConfig.controls.imageFile.setErrors({ size: true });
      } else {

        var self = this;
        var u = URL.createObjectURL(this.fileImg);
        var img = new Image;
        img.src = u;
        img.onload = function () {
          self.resizeImage(img, 200, 200);
        }
      }

    } else {
      // this.imageFile.setErrors({ required: true });
      this.imgContent = '';
      this.inputFileLabel = 'ESign_ts_1';
    }
  }

  getBase64String(blob, callback) {
    let self = this;
    var reader = new FileReader();
    reader.onload = function (e) {
      callback(reader.result, self);
    }

    reader.readAsDataURL(blob);
  }

  handle(str, self) {
    self.imgContent = str;
    self.formConfig.controls.base64Image.setValue(str.split(',')[1]);
  }

  // resize image 
  resizeImage(img, max_width, max_height) {
    var width = img.width;
    var height = img.height;

    // calculate the width and height, constraining the proportions
    if (width > height) {
      if (width > max_width) {
        //height *= max_width / width;
        height = Math.round(height *= max_width / width);
        width = max_width;
      }
    } else {
      if (height > max_height) {
        //width *= max_height / height;
        width = Math.round(width *= max_height / height);
        height = max_height;
      }
    }
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    canvas.width = width;
    canvas.height = height;
    ctx.drawImage(img, 0, 0, width, height);
    var self = this;
    let imgURL = ctx.canvas.toDataURL(this.fileImg.type, 1);
    this.urltoFile(imgURL, this.fileImg.name, this.fileImg.type).then(function (file) {
      self.fileImg = file;
      self.getBase64String(self.fileImg, self.handle);
    });
    canvas.remove();
  }

  urltoFile(url, filename, mimeType) {
    return (fetch(url)
      .then(function (res) { return res.arrayBuffer(); })
      .then(function (buf) { return new File([buf], filename, { type: mimeType }); })
    );
  }


  actCancel() {
    this.cancel.emit(null);
  }

  submit() {
    this.isSubmit = true;
    if (this.formConfig.valid) {
      this.alert.showAlert(this.translate.instant('UsbTokenConfig_ts_1'), ConstantAlertType.BLANK, true, "", this.translate.instant('btn_confirm'), () => {
        const param = {
          "serial": this.configId,
          "signBy": this.formConfig.value.signBy,
          "signDate": this.formConfig.value.signDate,
          "visibleType": +this.formConfig.value.visibleType || 0,
          "base64Image": this.formConfig.value.base64Image || default_img,
          "fontSize": this.formConfig.value.fontSize || 8
        }
        this.postUdpateUsbTokenConfig(param);
      }, "", this.translate.instant('btn_cancel'));
    }
  }

  postUdpateUsbTokenConfig(param) {
    this.signatureService.postUdpateUsbTokenConfig(param).subscribe((res: any) => {
      this.alert.showAlert(this.translate.instant('UsbTokenConfig_ts_2'), ConstantAlertType.SUCCESS, false, "", this.translate.instant('btn_close'))
    }, err => {
      console.log(err);
      this.alert.showErrorHandled(err);
    })
  }

  // //MARK: Popup thông báo
  // myAlert(msg, type, twoBtn = false, iconBtn2 = '', titleBtn2 = ConstantAlertBtn.OK, actBtn2 = () => { }, iconBtn1 = '', titleBtn1 = ConstantAlertBtn.CANCEL, actBtn1 = () => { }) {
  //   const modalRef = this.modalService.open(AlertComponent);
  //   modalRef.componentInstance.message = msg;
  //   modalRef.componentInstance.typeAlert = type;
  //   modalRef.componentInstance.twoBtn = twoBtn;
  //   modalRef.componentInstance.iconBtn1 = iconBtn1;
  //   modalRef.componentInstance.iconBtn2 = iconBtn2;
  //   modalRef.componentInstance.titleButton1 = titleBtn1;
  //   modalRef.componentInstance.titleButton2 = titleBtn2;
  //   modalRef.componentInstance.callback1 = actBtn1;
  //   modalRef.componentInstance.callback2 = actBtn2;
  // }

  // //MARK: Handle Error
  // handleError(err, errorMsg) {
  //   if (err.error && err.error.message && errorMsg[err.error.message]) {
  //     this.myAlert(errorMsg[err.error.message], 'error');
  //   } else if (err.error && err.error.error) {
  //     this.myAlert(err.error.error, 'error');
  //   } else {
  //     this.myAlert('Dịch vụ lỗi! Vui lòng thử lại.', 'error');
  //   }
  // }
}
